import { Button } from "@mui/material"

export const NotFound = () => {
    return (
      <div style={{
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center", 
        height: "100vh"
      }}>
        <h2>Page Not Found</h2>
        <p>Could not find requested resource</p>
        {/* add go login button */}
        <Button variant="contained" color="primary" onClick={() => window.location.href = "/signin"}>Go Signin</Button>
      </div>
    )
    }